import styles from "./toastScreenleft.module.scss";
import React from 'react';
import erroricon from "../../../../styles/images/erricons.svg";
export default function ToastUndo(props:any) {

  return (
    <>
      {/* <div className={styles.toastScreenleft}>
        <img src={nodata} alt="" />
        <span className="">1 message unsaved</span>
        <span className={styles.undoButton}>Undo</span>
        <span className="icon_close"></span>
      </div> */}
      <div className={styles.toastScreenleft}>
        <img src={erroricon} alt="" />
        <span className={styles.toastMsg}>{props?.message}</span>
        {props.undo &&<span className={styles.undoButton} onClick={props.onUndoClick}>Undo</span>}
        <span className="icon_close" onClick={props.closeToast}></span>
      </div>
    </>
  );
};

